import { render, staticRenderFns } from "./MasterDataCurriculumList.vue?vue&type=template&id=a101d156&"
import script from "./MasterDataCurriculumList.vue?vue&type=script&lang=js&"
export * from "./MasterDataCurriculumList.vue?vue&type=script&lang=js&"
import style0 from "./MasterDataCurriculumList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports